var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSide33(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5786 11.577C13.2476 11.577 14.6006 10.224 14.6006 8.555C14.6006 6.88601 13.2476 5.53302 11.5786 5.53302C9.90963 5.53302 8.55664 6.88601 8.55664 8.555C8.55664 10.224 9.90963 11.577 11.5786 11.577Z",
    stroke: "#E84242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.53297H2.51099V4.02198C2.51099 3.2205 2.82938 2.45185 3.39611 1.88512C3.96284 1.31839 4.73149 1 5.53297 1H17.6209C18.4224 1 19.191 1.31839 19.7577 1.88512C20.3245 2.45185 20.6429 3.2205 20.6429 4.02198V19.1319C20.6429 19.9333 20.3245 20.702 19.7577 21.2687C19.191 21.8355 18.4224 22.1538 17.6209 22.1538H5.53297C4.73149 22.1538 3.96284 21.8355 3.39611 21.2687C2.82938 20.702 2.51099 19.9333 2.51099 19.1319V17.6209H1",
    stroke: "#E84242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.5769H2.51099",
    stroke: "#E84242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.55493H2.51099",
    stroke: "#E84242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.5989H2.51099",
    stroke: "#E84242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1113 16.1099V14.5989C16.1113 13.7974 15.793 13.0288 15.2262 12.462C14.6595 11.8953 13.8908 11.5769 13.0894 11.5769H10.0674C9.26591 11.5769 8.49726 11.8953 7.93053 12.462C7.3638 13.0288 7.04541 13.7974 7.04541 14.5989V16.1099C7.04541 16.5106 7.2046 16.8949 7.48797 17.1783C7.77133 17.4617 8.15566 17.6209 8.5564 17.6209H14.6004C15.0011 17.6209 15.3854 17.4617 15.6688 17.1783C15.9521 16.8949 16.1113 16.5106 16.1113 16.1099Z",
    stroke: "#E84242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSide33);
export default __webpack_public_path__ + "static/media/side3.3.26a41f2fa15291ceb248e89085ef76df.svg";
export { ForwardRef as ReactComponent };